let codeConfigProd = {
    // Q-BANK
    QBANK: {
        PROBLEM: {
            TYPE: {
                // 선지형
                CHOICE: '01',
                // 서논술형
                ESSAY: '02',
                // 지문
                READING: '03',
                // 드래그드랍
                DRAGDROP: '04',
                // 단답형
                SHORT_ANSWER: '05',
            },
        },

        // 크리드
        READING: {
            // 지문 갈래 (글의 종류)
            PART: {
                NO_01: '동요',
                NO_02: '전래동요',
                NO_03: '동화',
                NO_04: '생활문',
                NO_05: '동시/시',
                NO_06: '극본/희곡',
                NO_07: '방송극본',
                NO_08: '시조',
                NO_09: '전설',
                NO_10: '방송 대본',
                NO_11: '민담',
                NO_12: '고전 소설',
                NO_13: '소설',
                NO_14: '신화',
                NO_15: '수필',
                NO_16: '만화',
                NO_17: '민요',
                NO_18: '노랫말',
                NO_19: '고려가요',
                NO_20: '향가',
                NO_21: '고전 수필',
                NO_22: '중수필',
                NO_23: '시나리오',
                NO_24: '뮤지컬 대본',
                NO_25: '우화',
                NO_26: '고대 가요',
                NO_27: '한시',
                NO_28: '서사 무가',
                NO_29: '설명문',
                NO_30: '그림일기/일기',
                NO_31: '편지',
                NO_32: '전기문',
                NO_33: '견학 기록문',
                NO_34: '독서 감상문',
                NO_35: '논설문',
                NO_36: '관찰 기록문',
                NO_37: '기행문',
                NO_38: '연설문',
                NO_39: '영화 감상문',
                NO_40: '조사 기록문',
                NO_41: '연극 감상문',
                NO_42: '안내문',
                NO_43: '기사문',
                NO_44: '광고문',
                NO_45: '음악 감상문',
                NO_46: '미술 감상문',
                NO_47: '서평',
                NO_48: '자서전',
                NO_49: '건의문',
                NO_50: '호소문',
                NO_51: '상소문',
                NO_52: '비평문',
                NO_53: '논평',
                NO_54: '촌평',
                NO_55: '면담 기사',
                NO_56: '선언문',
                NO_57: '이야기',
                NO_58: '그림책',
                NO_59: '드라마 대본',
                NO_60: '드라마',
                NO_61: '영화',
                NO_62: '소개하는 글',
                NO_63: '편지+전기문',
                NO_64: '일기+동화',
                NO_65: '독서감상문+편지',
                NO_66: '듣기 대본',
                NO_67: '극본+편지',
                NO_68: '전기문+동화',
                NO_69: '논설문+설명문',
                NO_70: '영화감상문+전기문',
                NO_71: '생활문+동화',
            },

            // 지문 구분
            TYPE: {
                NO_01: '문학',
                NO_02: '비문학',
                NO_03: '문학+비문학',
            },
        },
    },
};

export default codeConfigProd;
